// ----------------------------------------------------------------------------
// Функция возвращает куки с указанным name, или undefined, если ничего не найдено + проверка
// ----------------------------------------------------------------------------



import getCookie from "../get/getCookie.js";



const ttAuthGetCookie = (name) => {
     let value = getCookie(name);

    if (!value) return undefined;

    value = value.replace(/script|urlencode|alert|fetch|document|cookie|onload|onerror|urldecode|%3c|%3e|confirm|console|<|>|src|href|alt|eval|domain/ig, "");
    if (!value) return undefined; // если после вырезания ничего не осталось

    if (typeof value === "string" && value.length > 100) {
        return undefined; // если больше 100 символов, тоже возвращаем undefined
    }

    return value;
};

export default ttAuthGetCookie;